import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Planning } from '../../classes/planning.class';
import { PlanningDetailContainerComponent } from '../../pages/planning-overview/planning-detail-container/planning-detail-container.component';
import { ConfirmDialogService } from '../confirm-dialog-service/confirm-dialog.service';
import { PlanningService } from '../planning/planning.service';

@Injectable({
    providedIn: 'root',
})
export class PlanningDetailDialogService {
    constructor(
        private planningService: PlanningService,
        private confirmDialogService: ConfirmDialogService,
        public dialog: MatDialog
    ) {}

    openPlanning(planning: Planning) {
        const duplicatedPlanning = structuredClone(planning);
        if (planning.is_transport) {
            this.confirmDialogService
                .confirm({
                    title: 'Betreft transportplanning',
                    text: 'Deze planning kan alleen aangepast worden via de transportplanning.',
                    confirm: 'Sluiten',
                    cancel: null,
                })
                .then(() => {});
        } else {
            // This is needed to create object references between planninghas and cutters etc, needed for validation
            this.planningService.applyAllEntitiesToPlanningHas([duplicatedPlanning]);
            return this.dialog.open(PlanningDetailContainerComponent, {
                maxWidth: '99vw',
                maxHeight: '99vh',
                width: window.matchMedia('(max-width: 1520px)').matches ? '99vw' : '1500px',
                disableClose: true,
                restoreFocus: false,
                panelClass: 'planning-detail-dialog',
                data: duplicatedPlanning,
            });
        }
    }
}
